import * as types from './actionTypes';
// import api from '../../../api/mock';
import api from '../../../api/';

export function getData() {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const contributors = await api.getAllContributors();
      dispatch({
        type: types.LOADED,
        contributors,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
